<template>
  <el-dialog
    :before-close="chartBeforeClose"
    :title="meta.indicador_nome"
    :visible="visible"
    center>
    <el-row>
      <el-col>
        <table class="table-dark table-bordered table-striped table-hover" style="width: 100%">
          <tbody>
          <tr v-for="prop in listProps">
            <td> <span class="meta-label">{{ prop.label}}</span></td>
            <td> <span class="meta-value">{{prop.value}}</span></td>
          </tr>
          </tbody>
        </table>
      </el-col>
    </el-row>
  </el-dialog>
</template>

<script>
  export default {
    name: "DatailMeta",
    props: {
      visible: {
        default: false
      },
      meta: {
        required: false
      }
    },
    methods: {
      chartBeforeClose() {
        this.$emit('update:visible', false)
      }
    },
    computed: {
      listProps() {
        let lista = []
        lista.push({label: 'Meta', value: this.meta.meta})
        lista.push({label: 'Realizado', value: this.meta.realizado})
        lista.push({label: 'Formula', value: this.meta.formula})
        lista.push({label: 'Valores', value: this.meta.formula_render})
        lista.push({label: 'Peso', value: this.meta.peso})
        lista.push({label: 'Nota', value: this.meta.nota})
        lista.push({label: 'Spread', value: this.meta.spread_index})

        return lista
      }
    }
  }
</script>

<style scoped>
  .meta-label{
    padding: 1em;
    font-size: .8em;
  }

  .meta-value{
    padding: 1em;
    font-size: .8em;
  }
</style>



// WEBPACK FOOTER //
// src/features/Dashboard/Components/Shared/DatailMeta.vue